import { filter } from "lodash";

export const filterAddressByType = (addresses, type) => {
  const finalArray = filter(addresses, function (address) {
    return address.type === type;
  });
  return finalArray;
};
